// AccountPage.js
import React, {useEffect} from 'react';
import { Grid, Box } from '@mui/material';
import {useNavigate, Link} from 'react-router-dom';
import AccountDataCard from './AccountPCard/AccountDataCard';
import PointsCard from './AccountPCard/PointsCard';
import LogoutButtonCard from './AccountPCard/LogoutButtonCard';
import BarcodeCard from './BarcodeCard';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';

function AccountPage() {

  const { defaultTitle } = useTitle();
  const navigate = useNavigate();

  useEffect(() => {
    // 1. ローカルストレージから取得
    const customerCode = localStorage.getItem('customerCode');
    const customerId = localStorage.getItem('customerId');

    // 2. もしどちらか一方でもない場合 → サーバー問い合わせ or 即リダイレクト
    if (!customerCode || !customerId) {
      // サーバーでユーザーのメールアドレスや名前から問い合わせるなら
      // Auth.currentAuthenticatedUser() で Cognito ユーザーを取得し
      // fetch(...) などで問い合わせる処理を入れても良い。
      // ここでは単純化のため即リダイレクト
      navigate('/register-smaregi');
    }
  }, [navigate]);

  return (
          <div><Helmet>
            <title>{`${defaultTitle} - アカウントページ`}</title>
          </Helmet>
    <Grid container direction="column" spacing={2} justifyContent="center" alignItems="center" style={{ padding: '20px' }}>
      <Grid item xs={12} style={{ maxWidth: '600px', width: '100%' }}>
        <AccountDataCard />
      </Grid>
      {/* 新しく追加する BarcodeCard */}
      <Grid item xs={12} style={{ maxWidth: '600px', width: '100%' }}>
        <BarcodeCard />
      </Grid>
      <Grid item xs={12} style={{ maxWidth: '600px', width: '100%' }}>
        <PointsCard />
      </Grid>
      <Grid item xs={12} style={{ maxWidth: '600px', width: '100%' }}>
        <LogoutButtonCard />
      </Grid>
      <Grid item xs={12} style={{ maxWidth: '600px', width: '100%' }}>
        <Box textAlign="center">
          <Link to="/terms">利用規約</Link> | <Link to="/privacy">プライバシーポリシー</Link>
        </Box>
      </Grid>
    </Grid></div>
  );
}

export default AccountPage;
